<input type="file"
       hidden
       (change)="addFile($any($event.target).files)"
       [accept]="acceptTypes"
       [(ngModel)]="inputValue"
       #fileInput>

<div
    *ngIf="!value"
    class="file-input"
    [ngClass]="{ 'drag-over': isDragOver }"
    (click)="fileInput.click()"
    (dragover)="dragOver($event)"
    (dragleave)="isDragOver = false"
    (drop)="drop($event)">
    <div class="border-layer"></div>

    <div class="drop-zone-label-container">
        <div class="drop-zone-text">
            Drag and drop files or click to upload
            <cll-icon>upload</cll-icon>
        </div>
        <div *ngIf="hint"
             class="hint">
            {{ hint }}
        </div>
        <div class="hint">
            Maximum file size is {{ maxSize }}
        </div>
    </div>
</div>

<div *ngIf="value" class="file">
    <ng-container *ngIf="filePreview as thumbSrc; else fileIcon">
        <div
            *ngIf="filePreview as thumbSrc; else fileIcon"
            class="image-preview"
            [ngStyle]="{
                backgroundImage: 'url(' + thumbSrc + ')'
            }">
        </div>
    </ng-container>

    <ng-template #fileIcon>
        <cll-icon>description</cll-icon>
        <span>{{ value.name }}</span>
    </ng-template>

    <button *ngIf="!disableDelete"
            cll-icon-button
            (click)="removeFile()"
            cllTooltip="Clear image"
            type="button">
        <cll-icon>close</cll-icon>
    </button>
</div>
